import script from "./number.vue?vue&type=script&setup=true&lang=js"
export * from "./number.vue?vue&type=script&setup=true&lang=js"

import "./number.vue?vue&type=style&index=0&id=5d6f9f5c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6f9f5c"]])

export default __exports__